import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import _ from 'lodash';

import * as actions from '../actions';
import { PubnubState } from '..';

export const getBlockedUsersBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getBlockedUsers.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getBlockedUsers.fulfilled, (state, action) => {
      const reversedMessages = _.reverse(action.payload) || [];

      state.blocked.messages = [...state.blocked.messages, ...reversedMessages] || [];
      state.isBusy = false;
    })
    .addCase(actions.getBlockedUsers.rejected, (state) => {
      state.isBusy = false;
    });
};

export const getBlockedUsersCountBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.getBlockedUsersCount.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.getBlockedUsersCount.fulfilled, (state, action) => {
      const count = action.payload ? Object.values(action.payload)[0] : 0;

      state.blocked.total = count;
      state.isBusy = false;
    })
    .addCase(actions.getBlockedUsersCount.rejected, (state) => {
      state.isBusy = false;
    });
};
